import PropTypes from 'prop-types'
import React from 'react'

const FieldError = ({ message, show }) => {
  // role="alert" so assistive tech announces the message when it appears,
  // matching the .field__error treatment used everywhere else
  if (show)
    return (
      <div className="error" role="alert">
        {message}
      </div>
    )
  return null
}

FieldError.propTypes = {
  message: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired
}

export default FieldError
